import React, { useEffect, useRef, useState } from 'react';
import DownIcon from '@mui/icons-material/KeyboardArrowDown';
import cx from 'classnames';

import useOnClickOutside from '../../../../helpers/useOnClickOutside';
import RolePlate from '../../../modules/RolePlate';
import styles from './RoleDropdown.module.scss';
import { RolesLowerCase } from '../../../../enums';
import { Portal } from '../../../../helpers/bodyPortal';

interface RoleDropdownProps {
  onSelect: (role: string) => void;
  disabled?: boolean;
  selectedRole?: any;
}

const RoleDropdown: React.FC<RoleDropdownProps> = ({ onSelect, disabled = false, selectedRole }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement | null>(null);

  const toggleDropdown = (e: any) => {
    e.stopPropagation();
    if (!disabled) {
      setOpen(!open);
    }
  };

  const selectRole = (e: any, role: string) => {
    e.stopPropagation();
    setOpen(false);
    onSelect(role);
    updateScrollPosition();
  };

  useOnClickOutside(ref, (e) => {
    setOpen(false);
  });

  const updateScrollPosition = () => {
    const element = document.querySelector('#org_list');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
      });
    }
  };

  const [pos, setPos] = useState({ top: 0, left: 0 });
  useEffect(() => {
    if (ref.current) {
      const rect = ref.current.getBoundingClientRect();
      const top = rect.bottom + 126 > window.innerHeight ? rect.top - 120 : rect.bottom + 6;
      setPos({ top, left: Math.min(rect.left, window.innerWidth - 112) });
    }
  }, [onSelect, ref, open]);

  return (
    <div ref={ref} className={styles.dropdown}>
      <div onClick={toggleDropdown} className={styles.dropdownToggle}>
        {selectedRole && !disabled ? (
          <>
            <RolePlate userRole={selectedRole} />
            <DownIcon />
          </>
        ) : (
          <div className={cx(styles.roleSeletor, disabled ? styles.disabledRolesSelector : '')}>
            {' '}
            Role <DownIcon />{' '}
          </div>
        )}
      </div>
      {open && (
        <Portal>
          <div
            className={styles.dropdownMenu}
            style={{ top: `${pos.top}px`, left: `${pos.left}px`, position: 'fixed' }}
            onMouseDown={(e) => e.stopPropagation()}
          >
            <div onClick={(e) => selectRole(e, RolesLowerCase.ORGANIZATION_ADMIN)} className={styles.dropdownItem}>
              <RolePlate userRole="OA" />
            </div>
            <div onClick={(e) => selectRole(e, RolesLowerCase.ANALYST)} className={styles.dropdownItem}>
              <RolePlate userRole="Analyst" />
            </div>
            <div onClick={(e) => selectRole(e, RolesLowerCase.VIEWER)} className={styles.dropdownItem}>
              <RolePlate userRole="Viewer" />
            </div>
          </div>
        </Portal>
      )}
    </div>
  );
};

export default RoleDropdown;
